import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Column = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.6596 6H4.34043C4.15292 6 4 6.14668 4 6.32653V17.102C4 17.2819 4.15293 17.4286 4.34043 17.4286H19.6596C19.8471 17.4286 20 17.2819 20 17.102V6.32653C20 6.14668 19.8471 6 19.6596 6ZM4.68085 8.33486H11.6596V16.7755H4.68085V8.33486ZM12.3404 16.7755H19.3191V8.33486H12.3404V16.7755Z"
        />
    </StarryUIIcon>
);
